import gql from 'graphql-tag';

export const SubmitChecklistAnswer = gql`
  mutation submitChecklistAnswer($checklistAnswer: ChecklistAnswerCreate!) {
    submitChecklistAnswer(checklistAnswer: $checklistAnswer) {
      result
    }
  }
`;

export const EscalateCheck = gql`
  mutation escalateCheck($checklistAnswerItem: ChecklistAnswerItemCreate) {
    escalateCheck(checklistAnswerItem: $checklistAnswerItem) {
      result
      checkEscalationAttemptId
      error
    }
  }
`;
